export const CREATE_NOTIFICATION = "CREATE_NOTIFICATION";
export const CLEAR_NOTIFICATION = "CLEAR_NOTIFICATION";
